<div class="search-input common-mobile-number">
    <form [formGroup]="mobileSearchForm">
        <div class="driver-label drivermobile-number country-code" (focusin)="onFocusIn()" (focusout)="onFocusOut()">
            <label for="phone">Mobile Number </label>
            <div class="mobile-loader">
                <p-progressSpinner *ngIf="isLoading" strokeWidth="5"
                    [style]="{ width: '18px', height: '18px'}"></p-progressSpinner>
                <ngx-intl-tel-input [cssClass]="'custom'" [preferredCountries]="preferredCountries"
                    [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
                    [searchCountryField]="[searchCountryField.Iso2,searchCountryField.Name]"
                    [selectFirstCountry]="false" [selectedCountryISO]="countryISO" [maxLength]="10"
                    [phoneValidation]="true" [separateDialCode]="separateDialCode"
                    [numberFormat]="phoneNumberFormat.National" name="phone" id="phone" formControlName="phone"
                   (keydown)="onKeyDown($event)" customPlaceholder="Enter Mobile Number" (input)="onMobileTyping($event)">
                </ngx-intl-tel-input>
            </div>
           <div *ngIf="filteredMobile?.length && mobileSearchForm.get('phone')?.value && isShowDropdown" class="mobile-dropdown" #dropdownRef>
                <div
                  *ngFor="let data of filteredMobile; let i = index"
                  [class.highlighted]="i === activeIndex"
                >
                  <span (click)="onMobileSelectionChange(data)">
                    {{ data.mobileNumber ? data.mobileNumber : data.message }}
                  </span>
                </div>
              </div>
        </div>
        <div class="error-outer">
            <div
                *ngIf="!mobileSearchForm.get('phone').hasError('required') && mobileSearchForm.get('phone').touched && mobileSearchForm.get('phone').invalid">
                <small class="validation-error">Mobile number is not valid*</small>
            </div>
        </div>
    </form>
</div>